import { SEND_ADD_NEW_BOOKING_REQUEST } from '../constant/bookingConstant';

export function sendAddNewBookingRequest(data) {
  return {
    type: SEND_ADD_NEW_BOOKING_REQUEST,
    payload: data,
  }
};
